export const SIGN_IN = '/';
export const HOME = '/';
export const CONSULTANTS = '/consultants';
export const CLIENTS = '/clients';
export const CORPORATE = '/corporate';
export const CREDITS = '/credits';